import axios from '@/helpers/axios';
import { transferLineApi } from '@/helpers/apis';

export const getOptionsForTransfer = () => {
  const url = transferLineApi.GET_TRANSFER_OPTION;
  return axios.get(url);
};

export const getSetOfInstructionsForTransfer = (payload) => {
  const url = transferLineApi.GET_FORM_FIELDS_FOR_APPLICATION;
  return axios.post(url, payload);
};

export const uploadDocuments = (payload) => {
  const url = transferLineApi.GET_TRANSFER_LINE_UPLOAD_DOCUMENT;
  return axios.post(url, payload, { headers: { 'Content-Type': 'multipart/form-data' } });
};

export const downloadDocumentTransferLine = (documentId) => {
  const url = `${transferLineApi.GET_TRANSFER_LINE_DOWNLOAD_DOCUMENT}/${documentId}`;
  return axios.get(url, { responseType: 'blob' });
};

export const deleteDocumentTransferLine = (documentId) => {
  const url = `${transferLineApi.GET_TRANSFER_LINE_DELETE_DOCUMENT}/${documentId}`;
  return axios.post(url);
};

export const getTransferLineOrderSubmit = (payload) => {
  const url = transferLineApi.SUBMIT_ORDER_REQUEST_TRANSFER_LINE;
  return axios.post(url, payload);
};

export const getTransferLineRequestFinalSubmit = (payload) => {
  const url = transferLineApi.GET_FINAL_SUBMIT_ORDER_REQUEST;
  return axios.post(url, payload);
};

export const getTransferLinePersonalPlans = () => {
  const url = transferLineApi.GET_TRANSFER_MOBILE_LINE_PERSONAL_PLANS;
  return axios.get(url);
};
